import AddContactInfoContainer from './AddContactInfoContainer';

export default AddContactInfoContainer;